import { render } from "./stepConfirm.vue?vue&type=template&id=4ac584c8&scoped=true"
import script from "./stepConfirm.vue?vue&type=script&lang=js"
export * from "./stepConfirm.vue?vue&type=script&lang=js"

import "./stepConfirm.vue?vue&type=style&index=0&id=4ac584c8&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac584c8"]])

export default __exports__